/** Pure helpers for the Base64 tool's file mode (everything stays in the browser). */
export const MAX_FILE_BYTES = 3 * 1024 * 1024;

export function fileSizeLabel(n: number): string {
  if (n < 1024) return `${n} bytes`;
  if (n < 1024 * 1024) return `${(n / 1024).toFixed(1)} KB`;
  return `${(n / (1024 * 1024)).toFixed(1)} MB`;
}

/** null = fine; otherwise a clear message. */
export function fileSizeProblem(size: number, max = MAX_FILE_BYTES): string | null {
  if (size === 0) return "That file is empty.";
  if (size > max) return `This file is ${fileSizeLabel(size)}. Files up to ${fileSizeLabel(max)} are supported here, because the Base64 text is about a third larger and has to fit in this page. Try a smaller file.`;
  return null;
}

export const toDataUri = (base64: string, mime: string) => `data:${mime || "application/octet-stream"};base64,${base64}`;

/** Reads the MIME type from a data: URI, or null if the text is not one. */
export function dataUriMime(input: string): string | null {
  const m = /^\s*data:([^;,]*)((?:;[^;,]*)*),/i.exec(input);
  if (!m) return null;
  return m[1].trim() || "text/plain";
}

const EXT: Record<string, string> = {
  "image/png": "png", "image/jpeg": "jpg", "image/gif": "gif", "image/webp": "webp", "image/svg+xml": "svg",
  "application/pdf": "pdf", "text/plain": "txt", "text/html": "html", "application/json": "json", "text/csv": "csv",
  "audio/mpeg": "mp3", "video/mp4": "mp4", "application/zip": "zip",
};
export const extensionForMime = (mime: string | null): string => (mime && EXT[mime.toLowerCase()]) || "bin";
